import { render } from "./Description.vue?vue&type=template&id=1ee6f6b8"
import script from "./Description.vue?vue&type=script&lang=js"
export * from "./Description.vue?vue&type=script&lang=js"

import "./Description.vue?vue&type=style&index=0&id=1ee6f6b8&lang=scss"

import exportComponent from "C:\\Users\\gdfvs\\OneDrive\\桌面\\作品\\nintengo-game-list\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__